<template>
  <div class="container editForm">
    <img class="editImg" src="../../../assets/edit.png"/>
    <h3 class="editTitle better_font">You are in edit mode.</h3>
    <div v-for="school in schools" v-bind:key="school.id">
      <School :school_data="school" />
    </div>
    <div v-if="schools.length === 0">
      <img class="noSchools" src="../../../assets/emptySchools.png"/>
      <p class="editTitle">No schools are listed yet! Click the button below to start!</p>
      <button class="btn btn-primary btn-form better_font centered" @click="addSchool" type="button">Add School</button>
    </div>
    <div v-else>
      <button class="btn btn-primary btn-form better_font" @click="addSchool" type="button">Add Another School</button>
    </div>
    <button class="btn btn-primary btn-done better_font" @click="doneEditing">Done Editing</button>
  </div>
</template>

<script>
import axios from "axios"
import School from "./School.vue"
export default {
  name: "schools",
  components:{
    School
  },
  data(){
    return{
      schools: [],
      errors: []
    }
  },
  mounted(){
    this.getSchools()
  },
  methods:{
    getSchools(){
      axios.get(`${process.env.VUE_APP_ENDPOINT}/api/applicant/profile/schools/`)
      .then( res => {
        this.schools = res.data.schools
      })
      .catch( err => {
        this.errors.push(err)
      })
    },
    addSchool(){
      let new_school = { }
      this.schools.push(new_school)
    },
    doneEditing(){
      this.$emit('finishEdit');
    }
  }
}
</script>

<style scoped>

.centered {
  display: block;
  margin: 0 auto;
}


.noSchools {
  margin-right: 30%;
  margin-left: 30%;
  width: 40%;
}

.btn-form {
  background-color: #27AAE1;
  color: white;
}

.btn-form:hover {
  background-color: #1B86B5;
}

.editForm {
  background-color: #ededed;
  padding-right: 10%;
  padding-left: 10%;
  padding-top: 5%;
  padding-bottom: 5%;
  width: 100%;
}

.editImg {
  margin-left: 45%;
  margin-right: 45%;
  width: 10%;
}

.editTitle {
  color: #a6a6a6;
  text-align: center;
}

.btn-done {
  width: 50%;
  margin-left: 25%;
  margin-right: 25%;
  background-color: #a6a6a6;
  margin-top: 20px;
}

.btn-done:hover {
  background-color: #666;
}

</style>
